/**
 * Where the three flows go.
 *
 * All of them are paths on the game's own domain rather than the AWS hosts
 * behind them, and that is not cosmetic. A separate telemetry hostname is
 * exactly what content blockers exist to stop, and the players running them are
 * disproportionately the returning ones whose behaviour these numbers exist to
 * measure. A blocker that still refuses a first-party path is a preference to
 * respect; one that refuses it for the hostname is an artifact.
 *
 * CloudFront routes them to their Lambdas (backend/README.md).
 */
export const EVENTS_URL = '/api/events';
export const FIELD_URL = '/api/grid';

/**
 * The drop box, or `null` in a build that has none.
 *
 * The two flows above fail open — a dropped stat is nobody's business — so they
 * need no such switch. This one is watched by the person who pressed send, and
 * GDD §13's rule is that the entry point disappears rather than lying: a form
 * whose every send fails is worse than no form. Setting this to `null` hides
 * every way into the panel in one edit, which is what a build shipping ahead of
 * its stack, or ahead of the CloudFront behaviour, wants.
 */
export const FEEDBACK_URL: string | null = '/api/feedback';
